import identity from 'lodash/identity.js';
import isEmpty from 'lodash/isEmpty.js';
import keys from 'lodash/keys.js';
import pickBy from 'lodash/pickBy.js';
import sortBy from 'lodash/sortBy.js';
import values from 'lodash/values.js';
import queryString from 'query-string';

export default {
    /**
     * @param state
     * @param getters
     * @returns {*}
     */
    sorted(state, getters) {
        return () => sortBy(values(getters.all()), 'order');
    },

    /**
     * @param state
     * @returns {*}
     */
    sorting(state) {
        return pickBy(state.sort, identity);
    },

    /**
     * @param state
     * @param getters
     * @returns {boolean}
     */
    isSorting(state, getters) {
        return !isEmpty(getters.sorting);
    },

    urlWithQueryString(state, getters) {
        return url => url + getters.queryString;
    },

    /**
     * @param state
     * @param getters
     * @returns {string}
     */
    sortingQueryString(state, getters) {
        const sort = Object.keys(getters.sorting)
            .map(key => {
                const modifier = getters.sorting[key] === 'DESC' ? '-' : '';

                return modifier + key;
            })
            .join(',');

        return getters.isSorting ? queryString.stringify({ sort }) : '';
    },

    /**
     * @param state
     * @returns {function(*): boolean}
     */
    canSortBy(state) {
        return key => Boolean(keys(state.sort).includes(key));
    },
};
